import {jsonMember, jsonObject} from "typedjson";

@jsonObject
export class PitFilterTreeNodeType {
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  @jsonMember({name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _ord: number;

  @jsonMember({name: "name", constructor: String, emitDefaultValue: false, isRequired: false })
  private _name: string;

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get ord(): number {
    return this._ord;
  }

  set ord(value: number) {
    this._ord = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }
}
